<!-- MODAL detalleCajaDiaria -->
<div mdbModal #detalleCajaDiaria="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-fluid" style="max-width: 60%;" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Detalle de Caja Diaria
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="detalleCajaDiaria.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>

      <form autocomplete="off" [formGroup]="formData">
        <div class="modal-body">

          <div class="row">
            <div class="col" style="max-width: 200px;">
              <div class="md-form">
                <mdb-date-picker [inline]="true" name="fechaDetalle" formControlName="fechaDetalle"
                  [placeholder]="'Fecha'" required></mdb-date-picker>
              </div>
            </div>
            <!-- <div class="md-form" style="display: flex; align-items: center;">
              <h5>Fecha {{ fechaCaja }}</h5>
          </div> -->
            <div class="col" style="max-width: 300px;">
              <div class="md-form">
                <mdb-select [options]="optionsItem" formControlName="recaudacion" [filterEnabled]="true"
                  [highlightFirst]="false" placeholder="Recaudación"></mdb-select>
                <label>Recaudación</label>
              </div>
            </div>
            <div class="col" style="max-width: 250px;">
              <div class="md-form">
                <mdb-select [options]="optionsTipoPago" formControlName="listaTipoPago" [multiple]="true"
                  [filterEnabled]="true" [highlightFirst]="false" placeholder="Medios Pagos"></mdb-select>
                <label>Medios Pagos</label>
              </div>
            </div>
          </div>

          <div class="row justify-content-between" style="border-top: 1px solid #dee2e6;">
            <div></div>
            <button size="sm" class="btn btn-sm" mdbBtn type="button" color="info" (click)="buscar(1)" mdbWavesEffect>
              <mdb-icon fas icon="search"></mdb-icon>
              Buscar
            </button>
          </div>
          <!-- RESUMEN-->
          <div class="table-responsive mt-1" *ngIf="listaMovimientos">
            <table class="table table-striped table-hover table-sm align-middle">
              <thead class="grey lighten-2">
                <tr>
                  <th scope="col">Folio</th>
                  <th scope="col">Fecha pago</th>
                  <th scope="col">RUT</th>
                  <th scope="col">Detalle cliente</th>
                  <th scope="col">Monto</th>
                  <th scope="col">Nro. Doc</th>
                  <th scope="col">Banco</th>
                  <th scope="col">Recorrido</th>
                  <th scope="col">Medio Pago</th>
                </tr>
              </thead>
              <tbody>
                <td colspan="100%" style="text-align: center" *ngIf="loading">
                  <mdb-spinner spinnerColor="blue"></mdb-spinner>
                </td>
                <td colspan="100%" style="text-align: center" *ngIf="!loading && listaMovimientos?.length === 0">
                  No se encontró información
                </td>
                <tr *ngFor="let mov of listaMovimientos">
                  <td>
                    <span *ngIf="mov.existe_protesto === false">{{ mov.folio }}</span>
                    <span *ngIf="mov.existe_protesto" class="red-text">{{ mov.folio }}</span>
                  </td>
                  <td>
                    <span *ngIf="mov.existe_protesto === false">{{ mov.fecha_declaracion | fecha}}</span>
                    <span *ngIf="mov.existe_protesto" class="red-text">{{ mov.fecha_declaracion | fecha}}</span>
                  </td>
                  <td>
                    <span *ngIf="mov.existe_protesto === false">{{ mov.rutFormato | rut}}</span>
                    <span *ngIf="mov.existe_protesto" class="red-text">{{ mov.rutFormato | rut}}</span>
                  </td>
                  <td>
                    <span *ngIf="mov.existe_protesto === false">{{ mov.cliente_proveedor_nombre }}</span>
                    <span *ngIf="mov.existe_protesto" class="red-text">{{ mov.cliente_proveedor_nombre }}</span>
                  </td>
                  <td>
                    <span *ngIf="mov.existe_protesto === false">$ {{ mov.monto | numerico }}</span>
                    <span *ngIf="mov.existe_protesto" class="red-text">$ {{ mov.monto | numerico }}</span>
                  </td>
                  <td>
                    <span *ngIf="mov.tipo_pago_codigo === 1 && mov.existe_protesto === false">{{ mov.numero_doc }}</span>
                    <span *ngIf="mov.tipo_pago_codigo === 1 && mov.existe_protesto" class="red-text">{{ mov.numero_doc }}</span>
                    <span *ngIf="mov.tipo_pago_codigo === 3  || mov.tipo_pago_codigo === 2"></span>
                  </td>
                  <td>
                    <span *ngIf="mov.existe_protesto === false">{{ mov.banco_nombre | numerico }}</span>
                    <span *ngIf="mov.existe_protesto" class="red-text">{{ mov.banco_nombre | numerico }}</span>
                  </td>
                  <td>
                    <span *ngIf="mov.existe_protesto === false">{{ mov.recorrido_codigo }}</span>
                    <span *ngIf="mov.existe_protesto" class="red-text">{{ mov.recorrido_codigo }}</span>
                  </td>
                  <td>
                    <span *ngIf="mov.existe_protesto === false">{{ mov.tipo_pago_nombre }}</span>
                    <span *ngIf="mov.existe_protesto" class="red-text">{{ mov.tipo_pago_nombre }}</span>
                  </td>
                </tr>
              </tbody>
              <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
                *ngIf="listaMovimientos?.length > 0"></app-pagination>
            </table>
          </div>
        </div>
      </form>
      <div class="modal-footer justify-content-between">
        <button size="sm" type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal" 
          (click)="detalleCajaDiaria.hide()" mdbWavesEffect>
          Cerrar
        </button>
        <div>
          <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm"
            (click)="documentoDownloadExcelPdf('XLS')">
            Excel
          </button>
          <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm"
            (click)="documentoDownloadExcelPdf('PDF')">
            PDF
          </button>
        </div>
      </div>
    </div>
  </div>
</div>